import { render, staticRenderFns } from "./TaxForm.vue?vue&type=template&id=71dbaec7&scoped=true&"
import script from "./TaxForm.vue?vue&type=script&lang=js&"
export * from "./TaxForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxForm.vue?vue&type=style&index=0&id=71dbaec7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dbaec7",
  null
  
)

export default component.exports